




















































import { BIconRssFill } from 'bootstrap-vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    BIconRssFill
  }
})
export default class Navbar extends Vue {
  get $newYear() {
    const date = new Date();
    return date.getMonth() == 11 && date.getDate() >= 20
        || date.getMonth() == 0 && date.getDate() <= 10;
  }

  get $lang() {
    return (document.documentElement.lang || 'ru').toUpperCase();
  }

  get $toRussian() {
    return 'https://aleksandr.ru' + location.pathname;
  }

  get $toEnglish() {
    // https://aleksandr-ru.translate.goog/my/dccppthrottle?_x_tr_sl=ru&_x_tr_tl=en&_x_tr_hl=en-US
    return 'https://aleksandr-ru.translate.goog' + location.pathname + '?_x_tr_sl=ru&_x_tr_tl=en&_x_tr_hl=en-US';
  }

  mounted() {
    const items = (this.$refs.menu as Element).children;
    for (let i=0; i<items.length; i++) {
      const item = items.item(i);
      if (item) {
        if (item.classList.contains('dropdown')) {
          const ul: HTMLElement = Array.prototype.slice.apply(item.children).filter(item => item.tagName === 'UL').shift();
          if (ul) for (let k=0; k<ul.children.length; k++) {
            const a = ul.children.item(k)?.children.item(0) as HTMLAnchorElement;
            if (a && window.location.href.indexOf(a.href) > -1) item.classList.add('active');
          }
        }
        else {
          const a = item.children.item(0) as HTMLAnchorElement;
          if (a && window.location.href.indexOf(a.href) > -1) item.classList.add('active');
        }
      }
    }
  }
}
